import "./index.css";
import Button from '../button';

function Voice({ name, color, persona, icp, deleteVoice, handleEditVoice, isDeletable, linkedinStatus, linkedinEmail }) {

  return <div className='idea-item-border'>
    <div className='idea-item idea'>
    <div className='voice-title-holder'>
      <div className='voice-title-left'>
        <h2 style={{background: color, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent'}}>{name}</h2>
      </div>
    </div>
    <div className={`voice-linkedin-strip ${linkedinStatus || "none"}`}>
      <span className={`voice-linkedin-label ${linkedinStatus || "none"}`}>
        {linkedinStatus === "connected" ? "Account linked" : linkedinStatus === "pending" ? "Invite pending" : "Not connected"}
      </span>
      {linkedinEmail && <span className='voice-linkedin-email'>{linkedinEmail}</span>}
    </div>
    <div className='voice-info-holder'>
      <div className='voice-label-desc'>Persona</div>
      <div className='voice-content'>{persona}</div>
      <div className='voice-label-desc'>ICP</div>
      <div className='voice-content'>{icp}</div>
    </div>
    <div className='idea-action-bar'>
      <Button text="Edit" smallBool={true} addedFunction={handleEditVoice} />
      {isDeletable && (
        <Button text="Delete" smallBool={true} addedFunction={() => deleteVoice(name)} />
      )}
    </div>

    </div>
    </div>
}

export default Voice;
